<template>
  <div class="flex justify-center">
    <div class="flex items-center relative w-full justify-center">
      <transition name="transition-slide-fade-bottom-delay">
        <div v-if="!selectedEditToolId"
             class="flex items-center space-x-2 absolute top-0 w-full">
          <div v-for="(tool, index) in editToolIcons"
               @click="selectEditTool(index)"
               class="cursor-pointer">
            <div v-html="tool.svg"></div>
          </div>
          <div  :style="{ marginLeft: 'auto' }">
            <span @click="resetImage" class="font-bold text-gray-600 cursor-pointer">{{ $t('message.builder.imageEditor.reset') }}</span>
          </div>
        </div>
      </transition>
      <transition name="transition-slide-fade-bottom-delay">
        <div v-if="selectedEditToolId"
             class="text-center w-full md:w-full md:text-left md:flex md:items-center md:absolute md:top-0">
          <div class="md:pb-0 md:mr-8 font-bold">
            <p>{{ $t('message.builder.imageEditor.tools.' + editToolIcons[selectedEditToolId].name) }}</p>
          </div>
          <div v-if="toolInstructions"
               class="py-3 md:pt-0 md:pb-0">
            <p data-tool-instructions>{{ toolInstructions }}</p>
          </div>
          <div class="flex justify-center pb-4 md:pb-0 md:justify-start md:items-center md:ml-auto">
            <p @click="cancelEdit()"
               class="hidden md:block cursor-pointer p-2 mr-2">{{ $t('message.builder.imageEditor.cancel') }}</p>
            <button @click="cancelEdit()"
                    class="md:hidden w-auto btn border-gray-400 py-2 px-4 mr-2">{{ $t('message.builder.imageEditor.cancel') }}</button>
            <button @click="setEditTool(null)"
                    class="w-auto btn btn--dark py-2 px-4">{{ $t('message.builder.imageEditor.apply') }}</button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import * as editTools from '@vuedir/constants/editTools'
import { mapGetters, mapActions } from 'vuex'

/**
 * ImageEditor.vue
 */
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editToolIcons: editTools.EDIT_TOOL_ICONS,
    }
  },

  computed: {
    ...mapGetters({
      selectedEditToolId: 'image/selectedEditToolId',
      hasEdits: 'image/hasEdits'
    }),
    toolInstructions () {
      switch(this.selectedEditToolId) {
        case editTools.EDIT_TOOL_ZOOM:
        case editTools.EDIT_TOOL_CROP:

          return this.$t('message.builder.imageEditor.instructions.cropZoom.' + (this.isMobile ? 'mobile' : 'desktop'))
      }
    }
  },

  methods: {
    ...mapActions({
      setEditTool: 'image/setEditTool',
      resetImage: 'image/resetImage',
      cancelEdit: 'image/cancelEdit',
    }),
    selectEditTool(toolId) {
      this.setEditTool(parseInt(toolId))
    },
  }
}
</script>
